import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { ProductGroupDetailsComponent } from "./product-group-details/product-group-details.component";
import { ProductGroupListComponent } from "./product-group-list/product-group-list.component";
import { UnsavedChangesGuard } from "src/app/shared/guard/pending.guard";

const productGroupRoutes: Routes = [
  {
    path: "",
    component: ProductGroupListComponent,
  },
  { path: "reset", redirectTo: "group", pathMatch: "prefix" },
  {
    path: "group",
    component: ProductGroupDetailsComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: "group/:id",
    component: ProductGroupDetailsComponent,
    canDeactivate: [UnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(productGroupRoutes)],
  exports: [RouterModule],
})
export class ProductGroupRoutingModule {}
